import ImageService from '@/services/ImageService' 
import store from 'src/store'
const THREE = require('three')  
   
class Group extends THREE.Group { 

  constructor(config) { 

    super()
 
    this.views = []
    Object.assign(this, config)

    this.width = window.innerWidth
    this.height = window.innerHeight 
  } 
 
  tick(dt, time) { 
    for (var i = 0; i < this.views.length; i++) { this.views[i].tick(dt, time) }
  } 

  setReducedMotion(val){ 
    this.reduced_motion = val
    this.views.forEach( view => view.setReducedMotion( this.reduced_motion ) )
  }
 
  resize() {   
    this.views.forEach( view => view.resize() )
  } 

  createTexture(url){
    let img = ImageService.get(url)
    let texture = new THREE.Texture(img)
    texture.needsUpdate = true
    return texture
  }
  
  pointerMove(event){}

  pointerStart(event){}

  pointerEnd(event){}

  enter(){ }

  leave(){}


  // UPDATES -------------------------------------------------------------------
 

  // STATES -------------------------------------------------------------------
  
  /* modal states */ 

  modalNone(){ this.views.forEach( view => view.modalNone() ) }
  modalMenu(){  this.views.forEach( view => view.modalMenu() ) }
 
 
  // routes

  routeLoading(){ 
    this.render = false 
    this.views.forEach( view => view.routeLoading() ) 
  }
  
  routeHome(){ 
    this.render = true  
    this.views.forEach( view => view.routeHome() )
  }

  routeOneStar(){ this.views.forEach( view => view.routeOneStar() )}
  routeTwoStar(){ this.views.forEach( view => view.routeTwoStar() ) }
  routeThreeStar(){ this.views.forEach( view => view.routeThreeStar() ) }
  routeFourStar(){ this.views.forEach( view => view.routeFourStar() ) }
  routeFiveStar(){ this.views.forEach( view => view.routeFiveStar() ) }
   

  // load states

  mainLoaded(){ this.views.forEach( v => v.mainLoaded() ) }
  bubbleLoaded(){ this.views.forEach( v => v.bubbleLoaded() ) }
  characterLoaded(){ this.views.forEach( v => v.characterLoaded() ) }
  loadComplete(){ this.views.forEach( v => v.loadComplete() ) }

  
  // home states
  
  welcome(val, prev, dir){ this.views.forEach( view => view.welcome(val, prev, dir) ) }
  ratingFive(val, prev, dir){ this.views.forEach( view => view.ratingFive(val, prev, dir) ) }
  ratingFour(val, prev, dir){ this.views.forEach( view => view.ratingFour(val, prev, dir) ) }
  ratingThree(val, prev, dir){ this.views.forEach( view => view.ratingThree(val, prev, dir) ) }
  ratingTwo(val, prev, dir){ this.views.forEach( view => view.ratingTwo(val, prev, dir) ) }
  ratingOne(val, prev, dir){ this.views.forEach( view => view.ratingOne(val, prev, dir) ) }
  cta(val, prev, dir){ this.views.forEach( view => view.cta(val, prev, dir) ) }
 
 
}

export default Group